import { Link, useParams } from 'react-router-dom';
import { CalendarPlus } from 'lucide-react';
import { useCampaign } from '@/api/ads/hooks';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardBody } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, Th, Td, EmptyRow } from '@/components/ui/table';
import { Spinner } from '@/components/ui/spinner';
import { npr, fmtDate } from '@/lib/format';

export function CampaignDetailPage() {
  const { id } = useParams();
  const { data, isLoading } = useCampaign(id ? Number(id) : undefined);

  if (isLoading) return <Spinner label="Loading campaign…" />;
  if (!data) return <p className="text-muted-foreground">Campaign not found.</p>;

  return (
    <>
      <PageHeader
        title={data.name}
        description={data.objective || 'Campaign bookings'}
        action={
          <Link to={`/book?campaign=${data.id}`}>
            <Button>
              <CalendarPlus className="h-4 w-4" /> Add booking
            </Button>
          </Link>
        }
      />
      <Card>
        <CardBody className="p-0">
          <Table>
            <thead>
              <tr>
                <Th>Product</Th>
                <Th>Daypart</Th>
                <Th>Dates</Th>
                <Th>Slots</Th>
                <Th>Amount</Th>
                <Th>Status</Th>
                <Th />
              </tr>
            </thead>
            <tbody>
              {(data.bookings?.length ?? 0) === 0 && <EmptyRow colSpan={7}>No bookings in this campaign.</EmptyRow>}
              {data.bookings?.map((b) => (
                <tr key={b.id}>
                  <Td className="font-medium">{b.product_name}</Td>
                  <Td className="text-muted-foreground">{b.daypart_label ?? 'All day'}</Td>
                  <Td className="text-muted-foreground">
                    {fmtDate(b.start_date)} → {fmtDate(b.end_date)}
                  </Td>
                  <Td>{b.slots_requested}</Td>
                  <Td>{npr(b.total_amount)}</Td>
                  <Td>
                    <Badge status={b.status}>{b.status_display}</Badge>
                  </Td>
                  <Td className="text-right">
                    <Link to={`/bookings/${b.id}`}>
                      <Button variant="outline" size="sm">
                        Manage
                      </Button>
                    </Link>
                  </Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
}
